import _ from 'lodash';

import { Get, urls } from 'assets/js/api';
import VFGForm from 'assets/js/forms';

interface FormGetResponse {
  data: VFGForm;
}

export const MAX_FILESIZE_FOR_FORM_ATTACHMENT = 2 ** 27;

export async function getForm(formId: string): Promise<VFGForm> {
  const response: FormGetResponse = await Get(urls.FORM(formId));

  return response.data;
}
